  (function () {
    const root = document.querySelector('.ip-xsell[data-ip-xsell]');
    if (!root) return;

    const msg = root.querySelector('.ip-xsell__msg');
    const selectedPill = root.querySelector('[data-xsell-selected]');
    const addSelectedBtn = root.querySelector('[data-xsell-add-selected]');
    const subLine = root.querySelector('[data-xsell-sub]');
    const checks = Array.from(root.querySelectorAll('.ip-xsell__check'));

    function setMsg(text) {
      if (!msg) return;
      msg.textContent = text || '';
      if (text) {
        msg.classList.add('is-visible');
        window.clearTimeout(msg._t);
        msg._t = window.setTimeout(() => msg.classList.remove('is-visible'), 3200);
      } else {
        msg.classList.remove('is-visible');
      }
    }

    const ipMoneyFormatter = (function () {
try {
return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR',
maximumFractionDigits: 0 });
} catch (e) {
return null;
}
})();
function moneyFromCents(cents) {
const n = Number(cents || 0) / 100;
if (ipMoneyFormatter) return ipMoneyFormatter.format(n);
return '₹' + n.toFixed(0);
}

    function updateBubbleFromCart(cart) {
      const bubble = document.querySelector('.cart-count-bubble');
      if (!bubble) return;

      const count = Number(cart?.item_count || 0);
      bubble.classList.toggle('hidden', count === 0);

      const ariaHidden = bubble.querySelector('span[aria-hidden="true"]');
      const visuallyHidden = bubble.querySelector('.visually-hidden');

      if (ariaHidden) ariaHidden.textContent = String(count);
      if (visuallyHidden) visuallyHidden.textContent = `${count} items`;
    }

    async function refreshCartDrawer(responseJson) {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(responseJson);
        if (typeof cartDrawer.open === 'function') cartDrawer.open();
        return true;
      }

      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-notification-drawer');
      if (cartNotification && typeof cartNotification.renderContents === 'function') {
        cartNotification.renderContents(responseJson);
        return true;
      }
      return false;
    }

    function getSectionsForATC() {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        try { return cartDrawer.getSectionsToRender().map((s) => s.id).filter(Boolean); } catch(e){}
      }
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-notification-drawer');
      if (cartNotification && typeof cartNotification.getSectionsToRender === 'function') {
        try { return cartNotification.getSectionsToRender().map((s) => s.id).filter(Boolean); } catch(e){}
      }
      return ['cart-drawer', 'cart-notification', 'header'];
    }

    async function addVariantATC(variantId) {
      const sections = getSectionsForATC();

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      formData.append('sections', sections.join(','));
      formData.append('sections_url', window.location.pathname);

      const res = await fetch((window.Shopify?.routes?.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data?.description || 'Add failed');
      return data;
    }

    // PJ-10: add multiple cross-sell items in a single /cart/add.js request
    // (using the `items` array) instead of looping sequential awaited calls.
    // This is faster and avoids a partial-failure state where some items land
    // in the cart and others don't if one request in a loop were to fail.
    async function addVariantsATC(variantIds) {
      const sections = getSectionsForATC();

      const payload = {
        items: variantIds.map((id) => ({ id: isNaN(Number(id)) ? id : Number(id), quantity: 1 })),
        sections: sections,
        sections_url: window.location.pathname
      };

      const res = await fetch((window.Shopify?.routes?.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data?.description || 'Add failed');
      return data;
    }

    async function fetchCart() {
      const cartRes = await fetch((window.Shopify?.routes?.cart_url) ? (window.Shopify.routes.cart_url + '.js') : '/cart.js', {
        headers: { 'Accept': 'application/json' }
      });
      return cartRes.json();
    }

    function computeSelected() {
      const picked = checks.filter(c => c.checked && !c.disabled);
      const count = picked.length;
      const totalCents = picked.reduce((sum, c) => sum + Number(c.getAttribute('data-price-cents') || 0), 0);

      if (selectedPill) {
        selectedPill.hidden = count === 0;
        selectedPill.textContent = `${count} selected`;
      }
      if (addSelectedBtn) {
        addSelectedBtn.disabled = count === 0;
        addSelectedBtn.textContent = count ? `Add selected • ${moneyFromCents(totalCents)}` : 'Add selected';
      }
      if (subLine) {
        subLine.textContent = count ? `Extra learning added:: ${moneyFromCents(totalCents)}` : 'Pick from these to complete your order';
      }

      return picked.map(c => c.getAttribute('data-variant-id')).filter(Boolean);
    }

    // Update UI on check changes
    root.addEventListener('change', (e) => {
      if (e.target && e.target.classList.contains('ip-xsell__check')) {
        computeSelected();
      }
    });

    // Single add button (per row)
    root.addEventListener('click', async function (e) {
      const rowBtn = e.target.closest('.ip-xsell__btn');
      if (rowBtn) {
        const variantId = rowBtn.getAttribute('data-variant-id');
        if (!variantId) return;

        rowBtn.disabled = true;
        const textEl = rowBtn.querySelector('.ip-xsell__btn-text');
        const old = textEl ? textEl.textContent : '';
        if (textEl) textEl.textContent = 'Adding…';

        try {
          const data = await addVariantATC(variantId);
          const rendered = await refreshCartDrawer(data);

          const cart = await fetchCart();
          updateBubbleFromCart(cart);

          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: 'ip-xsell' } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart, source: 'ip-xsell' } }));
          // PJ-11: align with Dawn's native pub/sub cart-update mechanism (see
          // note above the batched "Add selected" handler for details).
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ip-xsell', productVariantId: variantId, cartData: data });
          }

          setMsg('Added');
          if (!rendered) {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
          }
        } catch (err) {
          setMsg('Could not add');
        } finally {
          rowBtn.disabled = false;
          if (textEl) textEl.textContent = old;
        }
        return;
      }

      // Add selected
      const addSelected = e.target.closest('[data-xsell-add-selected]');
      if (!addSelected) return;

      const ids = computeSelected();
      if (!ids.length) return;

      addSelected.disabled = true;
      const oldBtn = addSelected.textContent;
      addSelected.textContent = 'Adding…';

      try {
        // PJ-10: single batched request for all selected items.
        const data = await addVariantsATC(ids);

        const rendered = await refreshCartDrawer(data);

        const cart = await fetchCart();
        updateBubbleFromCart(cart);

        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: 'ip-xsell' } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart, source: 'ip-xsell' } }));
        // PJ-11: also publish through Dawn's native pub/sub (assets/pubsub.js +
        // assets/constants.js) so theme-wide cart listeners stay in sync with
        // how product-form.js announces cart updates. The custom cart:updated /
        // cart:refresh events above are left in place since cart:refresh is
        // relied on by the listener in layout/theme.liquid that syncs cart-drawer.
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ip-xsell', variantIds: ids, cartData: data });
        }

        setMsg('Added selected');

        if (!rendered) {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
        }

        // reset selection for clean UX
        checks.forEach(c => { if (!c.disabled) c.checked = false; });
        computeSelected();
      } catch (err) {
        setMsg('Could not add selected');
      } finally {
        addSelected.disabled = false;
        addSelected.textContent = oldBtn;
      }
    });

    // Collapse/Expand Toggle
    const summary = root.querySelector('.ip-xsell__sum');
    const content = root.querySelector('.ip-xsell__acc');
    const contentArea = root.querySelector('.ip-xsell__note-top');
    const listArea = root.querySelector('.ip-xsell__list');
    const barArea = root.querySelector('.ip-xsell__bar');
    let isOpen = true; // Start open by default

    function toggleOpen() {
      isOpen = !isOpen;
      content.classList.toggle('is-collapsed', !isOpen);
      contentArea.style.display = isOpen ? '' : 'none';
      listArea.style.display = isOpen ? '' : 'none';
      barArea.style.display = isOpen ? '' : 'none';
    }

    // Make entire header clickable
    if (summary) {
      summary.addEventListener('click', (e) => {
        // Don't toggle if clicking on the actual button elements
        if (!e.target.closest('button') && !e.target.closest('input')) {
          toggleOpen();
        }
      });
      summary.style.cursor = 'pointer';
    }

    // Make chevron clickable
    const chevron = root.querySelector('.ip-xsell__chev');
    if (chevron) {
      chevron.addEventListener('click', (e) => {
        e.stopPropagation();
        toggleOpen();
      });
      chevron.style.cursor = 'pointer';
    }

    // Init
    computeSelected();
  })();
